// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Photo{border:2.5vh solid #fff;cursor:zoom-out;left:50%;max-height:90vh;max-width:90vw;position:fixed;top:50%;transform:translate(-50%, -50%);z-index:500}.Photo-overlay{z-index:400}", ""]);
// Exports
module.exports = exports;
